import { useTranslation } from 'next-i18next';

import { Badge, Box, Flex, Text } from '@chakra-ui/react';

import { ScrollableWrapper } from '@nocowanie/common-ui';
import { IconProps } from '@nocowanie/icons';

import { MAX_AMENITY_COUNT } from '@app/consts';
import { getAmenityIcon } from '@app/helpers';
import { accommodationStaticSlice, useAppSelector } from '@app/state';

import { AmenitiesBarProps } from './amenities-bar.props';

export const AmenitiesBar = ({ ...props }: AmenitiesBarProps) => {
    const { t } = useTranslation('accommodation', {
        keyPrefix: 'basicInformation',
    });

    const { internalAmenityGroups } = useAppSelector(
        accommodationStaticSlice.selectors.selectAmenitiesData,
    );

    if (!internalAmenityGroups?.length) {
        return;
    }

    const iconConfig: IconProps = {
        size: 'md',
    };

    return (
        <Box backgroundColor="green.50" {...props} data-testid="amenities-bar">
            <ScrollableWrapper
                scrollableContainerProps={{
                    m: 0,
                    py: 6,
                    gap: 16,
                    scrollSnapType: 'none',
                    gridAutoColumns: {
                        base: 'max-content',
                        md: internalAmenityGroups.length > 3 ? 'auto' : 'max-content',
                    },
                    width: {
                        md: '100%',
                    },
                }}
            >
                {internalAmenityGroups.slice(0, MAX_AMENITY_COUNT).map((group, index) => {
                    return (
                        <Flex
                            display={'flex'}
                            alignItems={'center'}
                            gap={3}
                            key={index}
                            data-testid="amenities-bar-item"
                        >
                            {getAmenityIcon(group.type, iconConfig)}
                            <Flex flexDirection={'column'}>
                                <Text fontSize={'sm'} maxWidth={'76px'} width={'max-content'}>
                                    {group.label}
                                </Text>
                                {group.free && (
                                    <Badge
                                        variant={'solid'}
                                        px={1}
                                        py={0.5}
                                        colorPalette="green"
                                        textTransform={'uppercase'}
                                        fontSize={'2xs'}
                                        lineHeight={1}
                                    >
                                        {t('free')}
                                    </Badge>
                                )}
                            </Flex>
                        </Flex>
                    );
                })}
            </ScrollableWrapper>
        </Box>
    );
};
